export const SET_ALERT = 'SET_ALERT'
export const DROP_ALERT = 'DROP_ALERT'